import React from "react";
import Header from "../header";
import FooterBeta from "../footer/index-beta";
import "./style.css";
import AdminstrativeOffice from "../../pages/adminstrative_office";
import ArbitratorsSidebar from "../arbitrators_sidebar/custom";
import { useTranslation } from "react-i18next";
import {
  SelectedItemProvider,
  useSelectedItem,
} from "../../context/selectedItemContext";
import { useLocation, useParams } from "react-router-dom";

const ArbitratorsLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { selectedItemName, specializations } = useSelectedItem(); // specializations va category nameni contextdan olish

  return (
    <>
      <Header width={"100%"} />
      <div className="container mx-auto px-3 sm:px-5 lg:px-8">
        <div
          className="
      flex flex-col lg:flex-row
      min-h-[90vh]
      mx-auto
      pt-20 sm:pt-28 md:pt-32 lg:pt-36 xl:pt-40
      mb-5
    "
        >
          {/* SIDEBAR */}
          <div
            className="
        w-full
        lg:w-[280px]
        xl:w-[320px]
        2xl:w-[350px]
        mb-5 lg:mb-0
      "
          >
            <ArbitratorsSidebar />
          </div>

          {/* CONTENT */}
          <div
            className="
        w-full
        py-5 sm:py-7
        px-4 sm:px-6 lg:px-10
        border-t lg:border-t-0
        border-l-0 lg:border-l-2
        border-main_color
      "
          >
            <h3
              className={`
          text-base sm:text-lg md:text-xl xl:text-[22px]
          text-main_color font-semibold
          mb-4 sm:mb-5
          pl-0 lg:pl-3
          ${
            (location?.pathname === "/calculator" ||
              location?.pathname === "/contact") &&
            "hidden"
          }
        `}
            >
              {location?.pathname === "/calculator"
                ? ""
                : t(selectedItemName || "")}
            </h3>

            {children}

            <AdminstrativeOffice spesialization_id={Number(specializations)} />
          </div>
        </div>
      </div>

      <FooterBeta />
    </>
  );
};

// ArbitratorsLayoutni Context Providerga o'rab qo'yish
const ArbitratorsLayoutWithProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <SelectedItemProvider>
    <ArbitratorsLayout>{children}</ArbitratorsLayout>
  </SelectedItemProvider>
);

export default ArbitratorsLayoutWithProvider;
